module.exports = __webpack_public_path__ + "images/emoji/sound.8e189bc2cc8f5bbb8745.png";